import { render, staticRenderFns } from "./reportConfig.vue?vue&type=template&id=0aa77009&"
import script from "./reportConfig.vue?vue&type=script&lang=ts&"
export * from "./reportConfig.vue?vue&type=script&lang=ts&"
import style0 from "./reportConfig.vue?vue&type=style&index=0&id=0aa77009&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports